import { getCardValue, isRed, isThree } from "./card.js";
import { getMeldValue, isPureBook, isWildBook } from "./meld.js";
import { getActiveHand, getPlayer } from "./state.js";
export const PURE_BOOK_BONUS = 500;
export const WILD_BOOK_BONUS = 300;
export const RED_THREE_PENALTY = 500;
export const BLACK_THREE_PENALTY = 300;
/** Threes are pure liability; every other card costs its face value (§6). */
export function getPenaltyValue(card) {
    if (!isThree(card)) {
        return getCardValue(card);
    }
    return isRed(card) ? RED_THREE_PENALTY : BLACK_THREE_PENALTY;
}
function getPlayerPenalty(player) {
    const stranded = [...player.hand, ...player.foot];
    return stranded.reduce((total, card) => total + getPenaltyValue(card), 0);
}
export function scoreTeam(state, team) {
    const pureBooks = team.melds.filter(isPureBook).length;
    const wildBooks = team.melds.filter(isWildBook).length;
    const bookBonus = (pureBooks * PURE_BOOK_BONUS) + (wildBooks * WILD_BOOK_BONUS);
    const tableValue = team.melds.reduce((total, meld) => total + getMeldValue(meld), 0);
    const handPenalty = team.playerIds.reduce((total, playerId) => {
        const player = getPlayer(state, playerId);
        return player === undefined ? total : total + getPlayerPenalty(player);
    }, 0);
    return {
        teamId: team.id,
        pureBooks,
        wildBooks,
        bookBonus,
        tableValue,
        handPenalty,
        total: bookBonus + tableValue - handPenalty
    };
}
/** Scores every team for the round currently on the table (§6). */
export function scoreRound(state) {
    return {
        round: state.round,
        wentOutPlayerId: state.wentOutPlayerId,
        teams: state.teams.map((team) => scoreTeam(state, team))
    };
}
/** The active hand a player would be scored against; useful for bot heuristics. */
export function getActiveHandPenalty(player) {
    return getActiveHand(player).reduce((total, card) => total + getPenaltyValue(card), 0);
}
/** Teams tied for the highest cumulative score; meaningful once the game is complete (§2). */
export function getWinningTeamIds(state) {
    const best = state.teams.reduce((highest, team) => Math.max(highest, team.score), Number.NEGATIVE_INFINITY);
    return state.teams.filter((team) => team.score === best).map((team) => team.id);
}
//# sourceMappingURL=scoring.js.map